// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../public/Assets/Donation/PrivacyPolicy/backgroundImg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://api.fontshare.com/v2/css?f[]=satoshi@400,500,700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VotingRule {
  background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.4) 0%,
      rgba(7, 20, 20, 0.95) 40%,
      rgba(7, 20, 20, 1) 100%
    ),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 100%;
  min-height: 100vh;
  color: #dbdbdb;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  padding-bottom: 80px;
}

.VotingRule .privacyHeader {
  padding-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.VotingRule .privacyLogo {
  width: 107.49px;
  height: 83.19px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.VotingRule .privacyLogo:hover {
  transform: scale(1.05);
}

.VotingRule .privacyHeaderText {
  font-family: "Bebas Neue", sans-serif;
  font-size: 64px;
  letter-spacing: 2px;
  margin-top: 10px;
  color: #ffffff;
  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.6);
}

.VotingRule .privacyPolicyContainer {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.VotingRule .privacyPolicyContainer2 {
  width: 90% !important;
  max-width: 1380px !important;
  display: flex;
  flex-direction: column;
  background: rgba(13, 27, 27, 0.65);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(72, 209, 204, 0.15);
  border-radius: 16px;
  padding: 52px 64px;
  margin-top: 24px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
}

.VotingRule .lastUpdatedText {
  font-family: "Satoshi", sans-serif;
  font-size: 15px;
  color: #48d1cc;
  margin-bottom: 28px;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.VotingRule .legalSection {
  margin-top: 36px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.VotingRule .smallHeaderText {
  font-family: "Satoshi", sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.VotingRule .subSectionHeader {
  font-family: "Satoshi", sans-serif;
  font-size: 19px;
  font-weight: 600;
  color: #48d1cc;
  margin-top: 20px;
  margin-bottom: 10px;
}

.VotingRule .smallText {
  font-family: "Satoshi", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: #c9d6d6;
  margin-bottom: 14px;
}

.VotingRule .legalList {
  margin-top: 10px;
  margin-bottom: 16px;
  padding-left: 24px;
}

.VotingRule .legalList li {
  font-family: "Satoshi", sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  color: #b4c4c4;
  margin-bottom: 12px;
}

.VotingRule .legalList li strong {
  color: #e0f2f1;
  font-weight: 600;
}

.VotingRule .highlightBox {
  background: rgba(72, 209, 204, 0.08);
  border-left: 4px solid #48d1cc;
  padding: 16px 20px;
  border-radius: 6px;
  margin: 18px 0;
}

.VotingRule .highlightBox p {
  margin: 0;
  font-family: "Satoshi", sans-serif;
  font-size: 15px;
  line-height: 23px;
  color: #e0f2f1;
}

.VotingRule .emailText {
  color: #48d1cc;
  font-weight: 600;
  text-decoration: underline;
}

@media screen and (max-width: 1440px) {
  .VotingRule .privacyHeaderText {
    font-size: 54px;
  }
  .VotingRule .privacyPolicyContainer2 {
    width: 90% !important;
    padding: 44px 50px;
  }
  .VotingRule .smallHeaderText {
    font-size: 22px;
  }
}

@media screen and (max-width: 1024px) {
  .VotingRule .privacyHeaderText {
    font-size: 44px;
  }
  .VotingRule .privacyPolicyContainer2 {
    width: 94% !important;
    padding: 32px 30px;
  }
  .VotingRule .smallHeaderText {
    font-size: 20px;
  }
  .VotingRule .subSectionHeader {
    font-size: 17px;
  }
  .VotingRule .smallText {
    font-size: 15px;
    line-height: 24px;
  }
}

@media screen and (max-width: 768px) {
  .VotingRule .privacyHeader {
    padding-top: 24px;
  }
  .VotingRule .privacyLogo {
    width: 70px;
    height: 54px;
  }
  .VotingRule .privacyHeaderText {
    font-size: 36px;
  }
  .VotingRule .privacyPolicyContainer2 {
    width: 96% !important;
    padding: 24px 20px;
    border-radius: 12px;
  }
  .VotingRule .smallHeaderText {
    font-size: 18px;
  }
  .VotingRule .subSectionHeader {
    font-size: 16px;
  }
  .VotingRule .smallText {
    font-size: 14px;
    line-height: 22px;
  }
  .VotingRule .legalList {
    padding-left: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Donation/FAQSections/VotingRules/VotingRules.css"],"names":[],"mappings":"AAGA;EACE;;;;;;2CAM8E;EAC9E,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,4BAA4B;EAC5B,sBAAsB;EACtB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap\");\n@import url(\"https://api.fontshare.com/v2/css?f[]=satoshi@400,500,700&display=swap\");\n\n.VotingRule {\n  background-image: linear-gradient(\n      to bottom,\n      rgba(0, 0, 0, 0.4) 0%,\n      rgba(7, 20, 20, 0.95) 40%,\n      rgba(7, 20, 20, 1) 100%\n    ),\n    url(\"../../../../../public/Assets/Donation/PrivacyPolicy/backgroundImg.svg\");\n  width: 100%;\n  min-height: 100vh;\n  color: #dbdbdb;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-attachment: fixed;\n  padding-bottom: 80px;\n}\n\n.VotingRule .privacyHeader {\n  padding-top: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.VotingRule .privacyLogo {\n  width: 107.49px;\n  height: 83.19px;\n  cursor: pointer;\n  transition: transform 0.2s ease;\n}\n\n.VotingRule .privacyLogo:hover {\n  transform: scale(1.05);\n}\n\n.VotingRule .privacyHeaderText {\n  font-family: \"Bebas Neue\", sans-serif;\n  font-size: 64px;\n  letter-spacing: 2px;\n  margin-top: 10px;\n  color: #ffffff;\n  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.6);\n}\n\n.VotingRule .privacyPolicyContainer {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.VotingRule .privacyPolicyContainer2 {\n  width: 90% !important;\n  max-width: 1380px !important;\n  display: flex;\n  flex-direction: column;\n  background: rgba(13, 27, 27, 0.65);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border: 1px solid rgba(72, 209, 204, 0.15);\n  border-radius: 16px;\n  padding: 52px 64px;\n  margin-top: 24px;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);\n}\n\n.VotingRule .lastUpdatedText {\n  font-family: \"Satoshi\", sans-serif;\n  font-size: 15px;\n  color: #48d1cc;\n  margin-bottom: 28px;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n}\n\n.VotingRule .legalSection {\n  margin-top: 36px;\n  padding-top: 24px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.VotingRule .smallHeaderText {\n  font-family: \"Satoshi\", sans-serif;\n  font-size: 24px;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.VotingRule .subSectionHeader {\n  font-family: \"Satoshi\", sans-serif;\n  font-size: 19px;\n  font-weight: 600;\n  color: #48d1cc;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n\n.VotingRule .smallText {\n  font-family: \"Satoshi\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 26px;\n  color: #c9d6d6;\n  margin-bottom: 14px;\n}\n\n.VotingRule .legalList {\n  margin-top: 10px;\n  margin-bottom: 16px;\n  padding-left: 24px;\n}\n\n.VotingRule .legalList li {\n  font-family: \"Satoshi\", sans-serif;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 24px;\n  color: #b4c4c4;\n  margin-bottom: 12px;\n}\n\n.VotingRule .legalList li strong {\n  color: #e0f2f1;\n  font-weight: 600;\n}\n\n.VotingRule .highlightBox {\n  background: rgba(72, 209, 204, 0.08);\n  border-left: 4px solid #48d1cc;\n  padding: 16px 20px;\n  border-radius: 6px;\n  margin: 18px 0;\n}\n\n.VotingRule .highlightBox p {\n  margin: 0;\n  font-family: \"Satoshi\", sans-serif;\n  font-size: 15px;\n  line-height: 23px;\n  color: #e0f2f1;\n}\n\n.VotingRule .emailText {\n  color: #48d1cc;\n  font-weight: 600;\n  text-decoration: underline;\n}\n\n@media screen and (max-width: 1440px) {\n  .VotingRule .privacyHeaderText {\n    font-size: 54px;\n  }\n  .VotingRule .privacyPolicyContainer2 {\n    width: 90% !important;\n    padding: 44px 50px;\n  }\n  .VotingRule .smallHeaderText {\n    font-size: 22px;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .VotingRule .privacyHeaderText {\n    font-size: 44px;\n  }\n  .VotingRule .privacyPolicyContainer2 {\n    width: 94% !important;\n    padding: 32px 30px;\n  }\n  .VotingRule .smallHeaderText {\n    font-size: 20px;\n  }\n  .VotingRule .subSectionHeader {\n    font-size: 17px;\n  }\n  .VotingRule .smallText {\n    font-size: 15px;\n    line-height: 24px;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .VotingRule .privacyHeader {\n    padding-top: 24px;\n  }\n  .VotingRule .privacyLogo {\n    width: 70px;\n    height: 54px;\n  }\n  .VotingRule .privacyHeaderText {\n    font-size: 36px;\n  }\n  .VotingRule .privacyPolicyContainer2 {\n    width: 96% !important;\n    padding: 24px 20px;\n    border-radius: 12px;\n  }\n  .VotingRule .smallHeaderText {\n    font-size: 18px;\n  }\n  .VotingRule .subSectionHeader {\n    font-size: 16px;\n  }\n  .VotingRule .smallText {\n    font-size: 14px;\n    line-height: 22px;\n  }\n  .VotingRule .legalList {\n    padding-left: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
